import "./RootController";


export const rootState: ng.ui.IState = {
    name: "root",
    template: require("./root.html"),
    controller: "RootController",
    controllerAs: "vm"
};

angular.module("deliveryCreate.app").config([
    "$stateProvider",
    ($stateProvider: ng.ui.IStateProvider) => {
        $stateProvider.state(rootState);
    }
]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/root/rootState.ts
 **/